import localeText from '@/locales/datagrid'
import { useEffect } from 'react'
import FilterModelPro, {
    GridFilterItemPro,
    GridFilterModelPro,
    OperatorValue,
} from '../utils/filterModelPro'
import { GridColDefPro } from '../utils/types'
import FilterPanelSelect from './PanelSelect'

export default function FieldOperator({
    column,
    onFilterModelChange,
    item,
    className,
}: {
    column: GridColDefPro
    item: GridFilterItemPro
    onFilterModelChange: React.Dispatch<
        React.SetStateAction<GridFilterModelPro>
    >
    className?: string
}) {
    const operators = FilterModelPro.getOperators(column.type)
    const operatorValue = item.operatorValue ?? ''

    useEffect(() => {
        if (
            !operators
                .map(o => o.value as string)
                .includes(item.operatorValue as string)
        ) {
            onFilterModelChange(prev => ({
                ...prev,
                items: prev.items.map(p =>
                    p.id === item.id
                        ? {
                              ...p,
                              operatorValue: FilterModelPro.getDefaultOperator(
                                  column.type,
                              ),
                          }
                        : p,
                ),
            }))
        }
    }, [operators])

    return (
        <FilterPanelSelect<OperatorValue | ''>
            label={localeText.filterPanelOperator}
            value={operatorValue}
            options={operators as any}
            className={className}
            onValueChange={valor => {
                onFilterModelChange(prev => ({
                    ...prev,
                    items: prev.items.map(p =>
                        p.id === item.id
                            ? {
                                  ...p,
                                  operatorValue: valor || undefined,
                              }
                            : p,
                    ),
                }))
            }}
        />
    )
}
